import { SET_CUSTOMER } from '../action-types';
import { CreateCustomerRoutine } from '../redux-routines';

export const initialState = {
  data: {
    companyInformation: {
      contractType: '',
    },
    contactInformation: {},
  },
};

export const customerRegistrationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_CUSTOMER:
      return {
        ...state,
        data: {...state.data, ...action.payload}
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
